/**
 * `/ai-agents/config` is intentionally staff-only (security hardening
 * 6dcdb91). Student AI pages must not request it: student embed URLs come from
 * the interview/counsellor/tutor start endpoints instead. Keep this allowlist
 * in sync with the backend role check in routers/ai_agents.py.
 */
export const STAFF_AI_CONFIG_ROLES = new Set([
  'faculty',
  'university',
  'tpo',
  'admin',
  'system_admin',
]);

export const getCurrentUserRole = () => {
  if (typeof localStorage === 'undefined') return '';
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return String(user.role || '').trim().toLowerCase();
  } catch (error) {
    return '';
  }
};

export const shouldFetchStaffAiConfig = (role = getCurrentUserRole()) =>
  STAFF_AI_CONFIG_ROLES.has(String(role || '').trim().toLowerCase());
